import { usePageMeta } from "../lib/seo";
import { QuietCTA } from "../components/site/QuietCTA";

const steps = [
  {
    title: "First conversation.",
    body: "You describe the project; Rick explains how he works.",
  },
  {
    title: "The walkthrough.",
    body: "Rick walks the property with the subcontractors who would build it — crews he has worked with for years.",
  },
  {
    title: "The estimate.",
    body: "Built from his subcontractors' pricing. A realistic number rather than a low one.",
  },
  {
    title: "Scheduling.",
    body: "Sandquist takes no more than two or three projects at a time. Approved projects are scheduled accordingly.",
  },
  {
    title: "The build.",
    body: "Rick supervises in the field, start to finish, accountable for all the work.",
  },
  {
    title: "Completion.",
    body: "The lingering items get finished.",
  },
];

export default function Process() {
  usePageMeta(
    "How We Work | Sandquist Construction, Berkeley CA",
    "Six steps, from first conversation to the finished punch list. Rick Sandquist supervises every project personally, start to finish."
  );

  return (
    <main data-testid="process-page">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 sm:pt-24">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">How Rick works.</h1>
        <ol className="mt-14" data-testid="process-steps">
          {steps.map((step, i) => (
            <li key={i} className="border-t border-hairline py-8 sm:py-10 grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-3" data-testid={`process-step-${i + 1}`}>
              <div className="lg:col-span-4 flex items-baseline gap-5">
                <span className="font-label sc text-sm tracking-[0.18em] text-plaster" aria-hidden="true">
                  0{i + 1}
                </span>
                <h2 className="font-display text-2xl sm:text-3xl text-ink">{step.title}</h2>
              </div>
              <p className="lg:col-span-7 text-base sm:text-lg leading-relaxed text-inkmuted max-w-[65ch]">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="border-t border-hairline" />
      </div>
      <QuietCTA />
    </main>
  );
}
